import React from "react";
import { Total } from "./Total";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { Terms } from "./Terms";
import { OrderButton } from "./OrderButton";
import { useCreditSelector } from "../../stores/product/product.store";

interface OrderSectionProps {
    onSubmit: () => void;
}

export const OrderSection: React.FC<OrderSectionProps> = ({ onSubmit }) => {
    const text = useCreditSelector((state: CreditState) => state.text);
    const error = useCreditSelector((state: CreditState) => state.error);

    return (
        <>
            <div className="rounded-2xl bg-white p-4 mb-4">
                <p className="text-lg font-semibold mb-4">{ text.order }</p>
                <Total/>
                <div className="mt-6">
                    <Terms />
                </div>
            </div>
            { error && <div className="text-error mb2">{ error }</div> }
            <OrderButton onSubmit={ onSubmit } />
            <div className="m-2 bg-gray-200 w-full text-left">
            <p className="text-gray text-xs text-center"
                   dangerouslySetInnerHTML={ { __html: text.validOffer } }></p>
            </div>
        </>
    )
}